var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalIngresosBalken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #efb928;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    transform: "translate(5.57, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367-2",
    className: "cls-1",
    d: "M11.14,9.29h3.71c0-2.64-2.34-4.77-5.57-5.39V1.86C9.29.83,8.45,0,7.43,0c-1.03,0-1.86.83-1.86,1.86h0v2.04C2.34,4.51,0,6.65,0,9.29s2.34,4.77,5.57,5.39v3.62c-1.17-.39-1.86-1.06-1.86-1.58H0c0,2.64,2.34,4.77,5.57,5.39v2.04c0,1.03.83,1.86,1.86,1.86s1.86-.83,1.86-1.86h0v-2.04c3.23-.61,5.57-2.75,5.57-5.39s-2.34-4.77-5.57-5.39v-3.62c1.17.39,1.86,1.06,1.86,1.58ZM3.71,9.29c0-.52.69-1.19,1.86-1.58v3.16c-1.17-.39-1.86-1.06-1.86-1.58ZM11.14,16.71c0,.52-.69,1.19-1.86,1.58v-3.16c1.17.39,1.86,1.06,1.86,1.58h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIngresosBalken);
export default __webpack_public_path__ + "static/media/total-ingresos_BALKEN.cd29ac6125509448a2f2c966ba0b40bb.svg";
export { ForwardRef as ReactComponent };